<template>
    <v-row class="d-flex align-center flex-wrap ma-0 pa-0">

        <!-- Selezione vista calendario -->
        <v-btn-toggle v-model="localVista" mandatory class="rounded-lg my-toggle mr-2 mt-2" :dense="dense">
            <v-btn value="month" icon v-tooltip.bottom="'Vista mensile'">
                <v-icon>calendar_view_month</v-icon>
            </v-btn>
            <v-btn value="week" icon v-tooltip.bottom="'Vista settimanale'">
                <v-icon>calendar_view_week</v-icon>
            </v-btn>
            <v-btn value="day" icon v-tooltip.bottom="'Vista giornaliera'">
                <v-icon>calendar_view_day</v-icon>
            </v-btn>
            <v-btn value="agenda" icon v-tooltip.bottom="'Programma'">
                <v-icon>view_agenda</v-icon>
            </v-btn>
        </v-btn-toggle>

        <!-- Refresh -->
        <v-btn text icon class="ml-0 mt-2" v-tooltip.bottom="'Aggiorna'" @click="$emit('refresh')">
            <v-icon>refresh</v-icon>
        </v-btn>

        <!-- Navigazione mese/periodo -->
        <v-btn class="mt-2" text icon @click="$emit('prev')" v-tooltip.bottom="'Precedente'">
            <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>

        <v-btn class="mt-2 pl-0 pr-0" text small @click="$emit('oggi')"
            style="min-width: 90px; text-align: center; font-weight:600;">
            {{ periodoCorrente }}
        </v-btn>

        <v-btn class="mt-2" text icon @click="$emit('next')" v-tooltip.bottom="'Successivo'">
            <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>

        <!-- Aggiungi ore (solo desktop) -->
        <v-btn v-if="!$vuetify.breakpoint.smAndDown" small color="primary" class="mt-2" v-tooltip.bottom="'Segna ore'"
            @click="$emit('apriDialog')">
            <v-icon small>add</v-icon> Ore <v-icon small>schedule</v-icon>
        </v-btn>

        <!-- Aggiungi attività (solo desktop) -->
        <v-btn v-if="!$vuetify.breakpoint.smAndDown" small color="teal" class="mt-2 ml-2"
            v-tooltip.bottom="'Nuova attività / appuntamento'" @click="$emit('apriDialogTask')">
            <v-icon small>add</v-icon> Attività <v-icon small>task_alt</v-icon>
        </v-btn>

        <!-- Filtro utente -->
        <v-select v-if="role === 'admin'" class="ml-2 mt-2" :items="filtriUtenti" v-model="localFiltroUtenteSel"
            label="Utente" hide-details :dense="dense" @change="$emit('refresh')" style="max-width: 120px;" />

        <!-- Esporta -->
        <v-btn v-if="role === 'admin'" icon color="primary" class="ml-2 mt-2" v-tooltip.bottom="'Esporta Excel'"
            @click="$emit('esportaExcel')">
            <v-icon>grid_on</v-icon>
        </v-btn>

        <!-- ── Menu filtri visualizzazione ── -->
        <v-menu v-model="menuFiltri" offset-y left :close-on-content-click="false" min-width="260">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="mt-2 ml-1" v-bind="attrs" v-on="on" v-tooltip.bottom="'Filtri visualizzazione'"
                    :color="filtriAttivi ? 'primary' : ''">
                    <v-badge v-if="filtriAttivi" color="primary" dot overlap>
                        <v-icon>filter_list</v-icon>
                    </v-badge>
                    <v-icon v-else>filter_list</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="pb-1 pt-3 px-4" style="font-size:13px !important; font-weight:600;">
                    Filtri visualizzazione
                </v-card-title>
                <v-divider />

                <v-list dense class="py-1">

                    <!-- Mostra ore -->
                    <v-list-item class="px-4">
                        <v-list-item-action class="mr-3 my-0">
                            <v-switch v-model="localMostraOre" hide-details dense color="primary"
                                @change="$emit('refresh')" />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="body-2">Mostra ore</v-list-item-title>
                            <v-list-item-subtitle style="font-size:11px;">Registro ore lavorate</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon class="my-auto ml-2">
                            <v-icon small :color="localMostraOre ? 'primary' : 'grey lighten-1'">schedule</v-icon>
                        </v-list-item-icon>
                    </v-list-item>

                    <!-- Mostra attività -->
                    <v-list-item class="px-4">
                        <v-list-item-action class="mr-3 my-0">
                            <v-switch v-model="localMostraTask" hide-details dense color="teal"
                                @change="$emit('refresh')" />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="body-2">Mostra attività</v-list-item-title>
                            <v-list-item-subtitle style="font-size:11px;">Appuntamenti, riunioni,
                                note</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon class="my-auto ml-2">
                            <v-icon small :color="localMostraTask ? 'teal' : 'grey lighten-1'">task_alt</v-icon>
                        </v-list-item-icon>
                    </v-list-item>

                    <v-divider class="my-1" />

                    <!-- Attività completate — sub-filtro, disabilitato se mostraTask è off -->
                    <v-list-item class="px-4" :disabled="!localMostraTask">
                        <v-list-item-action class="mr-3 my-0">
                            <v-switch v-model="localMostraCompletate" hide-details dense color="green"
                                :disabled="!localMostraTask" @change="$emit('refresh')" />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="body-2"
                                :class="!localMostraTask ? 'grey--text text--lighten-1' : ''">
                                Attività completate
                            </v-list-item-title>
                            <v-list-item-subtitle style="font-size:11px;">
                                Solo per le attività, non per le ore
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon class="my-auto ml-2">
                            <v-icon small
                                :color="localMostraCompletate && localMostraTask ? 'green' : 'grey lighten-1'">
                                done_all
                            </v-icon>
                        </v-list-item-icon>
                    </v-list-item>

                    <!-- Promemoria — sub-filtro, disabilitato se mostraTask è off -->
                    <v-list-item class="px-4" :disabled="!localMostraTask">
                        <v-list-item-action class="mr-3 my-0">
                            <v-switch v-model="localMostraPromemoria" hide-details dense color="blue-grey"
                                :disabled="!localMostraTask" />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="body-2"
                                :class="!localMostraTask ? 'grey--text text--lighten-1' : ''">
                                Mostra promemoria
                            </v-list-item-title>
                            <v-list-item-subtitle style="font-size:11px;">
                                Attività senza orario
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon class="my-auto ml-2">
                            <v-icon small
                                :color="localMostraPromemoria && localMostraTask ? 'blue-grey' : 'grey lighten-1'">
                                notifications
                            </v-icon>
                        </v-list-item-icon>
                    </v-list-item>

                </v-list>

                <v-divider />
                <v-card-actions class="px-4 py-2">
                    <v-btn x-small text color="grey" @click="resetFiltri">Ripristina tutti</v-btn>
                    <v-spacer />
                    <v-btn x-small text color="primary" @click="menuFiltri = false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
        <v-spacer />

        <v-chip class="ml-3 mt-2 pt-0">
            Totale ore: {{ totaleOreLavoro }}
        </v-chip>
        <!-- Cerca -->
        <v-text-field v-model="localSearch" append-icon="search" label="Cerca" hide-details clearable
            class="ml-2 pb-1 mt-2" :dense="dense" style="max-width: 180px;" />
    </v-row>
</template>

<script>
export default {
    props: {
        today: String,
        role: String,
        vista: { type: String, default: 'month' },
        filtroUtenteSel: String,
        filtriUtenti: Array,
        mostraCompletate: Boolean,
        mostraPromemoria: { type: Boolean, default: true },
        mostraOre: { type: Boolean, default: true },
        mostraTask: { type: Boolean, default: true },
        search: String,
        dense: Boolean,
        totaleOreLavoro: String,
    },

    data: () => ({
        menuFiltri: false,
    }),

    computed: {
        periodoCorrente() {
            const d = new Date(this.today + 'T00:00:00');
            if (this.vista === 'month' || this.vista === 'agenda') {
                return d.toLocaleString('it', { month: 'long', year: 'numeric' });
            }
            if (this.vista === 'week') {
                // Inizio settimana (lunedì)
                const day = d.getDay() || 7;
                const lunedi = new Date(d);
                lunedi.setDate(d.getDate() - day + 1);
                const domenica = new Date(lunedi);
                domenica.setDate(lunedi.getDate() + 6);
                return `${lunedi.getDate()}/${lunedi.getMonth() + 1} - ${domenica.getDate()}/${domenica.getMonth() + 1}`;
            }
            if (this.vista === 'day') {
                return d.toLocaleDateString('it', { weekday: 'short', day: 'numeric', month: 'short' });
            }
            return '';
        },

        filtriAttivi() {
            return !this.mostraOre || !this.mostraTask || this.mostraCompletate || !this.mostraPromemoria;
        },

        localVista: {
            get() { return this.vista; },
            set(v) { this.$emit('update:vista', v); },
        },
        localFiltroUtenteSel: {
            get() { return this.filtroUtenteSel; },
            set(v) { this.$emit('update:filtroUtenteSel', v); },
        },
        localMostraCompletate: {
            get() { return this.mostraCompletate; },
            set(v) { this.$emit('update:mostraCompletate', v); },
        },
        localMostraPromemoria: {
            get() { return this.mostraPromemoria; },
            set(v) { this.$emit('update:mostraPromemoria', v); },
        },
        localMostraOre: {
            get() { return this.mostraOre; },
            set(v) { this.$emit('update:mostraOre', v); },
        },
        localMostraTask: {
            get() { return this.mostraTask; },
            set(v) { this.$emit('update:mostraTask', v); },
        },
        localSearch: {
            get() { return this.search; },
            set(v) { this.$emit('update:search', v); },
        },
    },

    methods: {
        resetFiltri() {
            this.$emit('update:mostraOre', true);
            this.$emit('update:mostraTask', true);
            this.$emit('update:mostraCompletate', false);
            this.$emit('update:mostraPromemoria', true);
            this.$emit('refresh');
        },
    },
};
</script>

<style scoped></style>